import React from 'react';
import CategoryFilter from 'components/CategoryFilter/CategoryFilter';
import NoResultsForKeywordText from './NoResultsForKeywordText/NoResultsForKeywordText';
import { useIntl } from 'react-intl';
import { NoResultsFoundProps } from 'models/NoResultsFoundProps';
import NoResultsImage from './NoResultsImage/NoResultsImage';
import { MainContentWrapper } from 'styles/Page.styles';
import SearchOptions from 'components/SearchOptions/SearchOptions';
import { Divider } from 'components/Divider/Divider.styles';
import { CategoryFilterTitle } from './CategoryFilterTitle.styles';

const NoResultsFound = ({
  categoryList,
  activeFilters
}: NoResultsFoundProps) => {
  const { formatMessage } = useIntl();
  const internationalSearch =
    formatMessage({ id: 'INTERNATIONAL_SEARCH' }) === 'true' &&
    !!activeFilters.q;
  const title = internationalSearch ? (
    <CategoryFilterTitle>
      {formatMessage({
        id: 'RESULT_LIST.NO_RESULTS.INTERNATIONAL_SEARCH.SEARCH_IN_CATEGORIES'
      })}
    </CategoryFilterTitle>
  ) : /* istanbul ignore next */ undefined;

  return (
    <MainContentWrapper>
      <NoResultsImage />
      <NoResultsForKeywordText
        internationalSearch={internationalSearch}
        categoryListPresent={categoryList.length > 0}
      />
      {internationalSearch && (
        <>
          <SearchOptions activeFilters={activeFilters} />
          <Divider />
        </>
      )}
      <CategoryFilter
        categoryList={categoryList}
        activeFilters={activeFilters}
        styledAsButtons
        title={title}
      />
    </MainContentWrapper>
  );
};

export default NoResultsFound;
